import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  computed: {
    columns () {
      const arr = [
        getCopyWithContentTableColumn({
          field: 'id',
          title: i18n.t('scope.text_438'),
        }),
        getNameDescriptionTableColumn({
          field: 'title',
          title: i18n.t('scope.text_439'),
          edit: false,
          onManager: this.onManager,
          hideField: true,
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.title }</side-page-trigger>
            )
          },
        }),
        {
          field: 'status',
          title: i18n.t('scope.text_426'),
          formatter: ({ cellValue }) => {
            const obj = {
              init: i18n.t('scope.bill.status.init'),
              open: i18n.t('scope.bill.status.open'),
              cancelled: i18n.t('scope.text_456'),
              close: i18n.t('scope.bill.status.close'),
              onpay: i18n.t('scope.bill.status.onpay'),
              due: i18n.t('scope.bill.status.due'),
              paid: i18n.t('scope.bill.status.paid'),
              revoke: i18n.t('scope.bill.status.revoke'),
              onrefund: i18n.t('scope.bill.status.onrefund'),
              refund: i18n.t('scope.bill.status.refund'),
            }
            return obj[cellValue]
          },
        },
        {
          field: 'count',
          title: i18n.t('scope.text_440'),
          minWidth: 70,
        },
        {
          field: 'origin_amount',
          title: i18n.t('scope.text_441'),
          minWidth: 100,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        },
        {
          field: 'amount',
          title: i18n.t('scope.text_298'),
          minWidth: 100,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        },
        {
          field: 'currency',
          title: i18n.t('scope.text_442'),
          minWidth: 70,
        },
        getTimeTableColumn({ title: i18n.t('scope.text_443'), field: 'since' }),
        getTimeTableColumn({ title: i18n.t('scope.text_444'), field: 'until' }),
      ]
      if (this.cloudEnv === 'due') {
        arr.push(getTimeTableColumn({ title: i18n.t('scope.text_445'), field: 'due_at' }))
        arr.push(getTimeTableColumn({ title: i18n.t('scope.text_446'), field: 'deadline' }))
      } else {
        arr.push({
          field: 'coupon_amount',
          title: i18n.t('scope.text_447'),
          minWidth: 100,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        })
        arr.push({
          field: 'paid_amount',
          title: i18n.t('scope.text_448'),
          minWidth: 120,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        })
        arr.push({
          field: 'paid_currency',
          title: i18n.t('scope.text_449'),
          minWidth: 70,
        })
      }
      return arr
    },
  },
}
